export enum NarrativeContentStyleType {
  PODCAST = "PODCAST",
  COMEDY = "COMEDY",
  TUTORIALS = "TUTORIALS",
  TESTIMONIALS = "TESTIMONIALS",
  CONTROVERSIAL_EXPERT = "CONTROVERSIAL_EXPERT",
  DARK_CONSPIRANCY = "DARK_CONSPIRANCY",
  HONEST_REVIEW = "HONEST_REVIEW"
}

export enum NarrativeContentStyleTypeTranslateToSpanish {
  PODCAST = "Podcast",
  COMEDY = "Comedia",
  TUTORIALS = "Tutoriales",
  TESTIMONIALS = "Testimonios",
  CONTROVERSIAL_EXPERT = "Experto Polémico",
  DARK_CONSPIRANCY = "Conspiración Oscura",
  HONEST_REVIEW = "Reseña Honesta"
}

export enum NarrativeContentType {
  ORGANIC = "ORGANIC",
  SALES = "SALES"
}
